import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { newTypeRegimenSchema } from '@/shared';
import { useCreateTypeRegimen, useUpdateTypeRegimenes } from '@/shared/actions/erp';
import {

  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { TYPERegimens } from '@/shared/interfaces';

const returnUrlType = '/parametrizacion/tipo-regimenes';

export type SaveTypeRegimenesInterface = {
  titlePage: string;
  editTypeRegimens?: TYPERegimens;
}
type SaveFormData = {
  nombre: string;
  estado: boolean;
  //codigo: string
}

const SaveTypeRegimenes: React.FC<SaveTypeRegimenesInterface> = ({ titlePage, editTypeRegimens }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);
  ///* mutations
  const createRegimensMutation = useCreateTypeRegimen({ navigate, returnUrl: returnUrlType });
  const updateRegimensMutation = useUpdateTypeRegimenes({ navigate, returnUrl: returnUrlType });
  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newTypeRegimenSchema),
    defaultValues: { estado: false }, // Set default value for estado
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;
  ///*handlres
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editTypeRegimens?.id_tipo_regimen) {
      return updateRegimensMutation.mutate({
        id: editTypeRegimens.id_tipo_regimen,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createRegimensMutation.mutate(form.getValues() as any);
  };
  ///* effects
  useEffect(() => {
    if (editTypeRegimens) {
      setShrink(true);
      reset({
        nombre: editTypeRegimens.nombre,
        codigo: editTypeRegimens.codigo,
        estado: editTypeRegimens.estado,
      } as any);
    }
  }, [editTypeRegimens]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlType);
      }}
      onSave={handleSubmit(onSave)}
    >
     {/*  <CustomTextField
        name="codigo"
        label="Codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ""}
        error={errors.codigo}
        helperText={errors.codigo?.message}
        shrink={shrink}
      /> */}
      <CustomTextField
        name="nombre"
        label="Nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado || false}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveTypeRegimenes;